import type { MemoItem } from './renderMemo.js'
import type { MemoBlock } from './schema.js'

/** Whether the block lists `item` under its top news subheading. */
export function isTopNews(block: MemoBlock | undefined, item: MemoItem): boolean {
  const topNews = block?.topNews

  if (!topNews || !item.newsvalue) {
    return false
  }

  return topNews.types.includes(item.sourceType)
    && topNews.newsvalues.some((newsvalue) => newsvalue === item.newsvalue)
}

/**
 * The block's top news, highest newsvalue first and then in the order they are
 * given, and everything else as it was. The desk order is set when an item is
 * picked, so an order the editor arranges by hand stays.
 */
export function splitTopNews(
  block: MemoBlock,
  items: MemoItem[]
): { top: MemoItem[], rest: MemoItem[] } {
  const top = items
    .filter((item) => isTopNews(block, item))
    .sort((a, b) => Number(b.newsvalue) - Number(a.newsvalue))

  return { top, rest: items.filter((item) => !isTopNews(block, item)) }
}
